import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../modal.service';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { PROJECTS } from '@core/enum/projects.enum';

@Component({
  selector: 'shell-info-not-loaded',
  templateUrl: './info-not-loaded.component.html',
  styleUrls: ['./info-not-loaded.component.scss'],
})
export class InfoNotLoadedComponent implements OnInit {
  modalError: any;
  constructor(
    public modalService: ModalService,
    public messageBus: MessageBusService,
    public microFrontendRouter: MicroFrontendRouter,
  ) {}

  closeModal() {
    switch (this.modalError?.project) {
      case PROJECTS.FTD:
        if (this.modalError.payload) {
          if (this.modalError.payload.gotoMain) {
            this.microFrontendRouter.navigateByUrl(
              '/plazo-fijo/abrir-deposito/datos-personales',
              'plazo-fijo',
            );
          }
        }
        break;
    }
    this.modalService.close();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.modalError = this.messageBus.getValue('shell', 'modal.error');
    });
  }
}
